import translationData from "./csvjson";

let enTranslation = {};
let jaTranslation = {};
let cnTranslation = {};
for (let index in translationData) {
  let key = translationData[index]["machine_name (Elasticsearch)"];
  let enVal = translationData[index]["EN label"];
  let jaVal = translationData[index]["JA label"];
  let cnVal = translationData[index]["CN label"];
  enTranslation[key] = enVal;
  jaTranslation[key] = jaVal;
  cnTranslation[key] = cnVal;
}

export const en = { translations: enTranslation };
export const ja = { translations: jaTranslation };
export const cn = { translations: cnTranslation };
